/** @jsx jsx */
import { Box, Container, Flex, Heading } from "@eworkit/iris";
import { FC } from "react";
import { Grid, jsx } from "theme-ui";

import { IPublicProfileInfo, PublicProfile } from "@/data/public-profiles";

import { ClientPageCoverImage, ClientPageLogo, ClientPageNavigationTabs } from "./components";

interface ClientPageHeaderProps {
  publicProfile: PublicProfile;
  info?: IPublicProfileInfo;
  isPublic?: boolean;
  forceActiveTab?: string;
}

export const ClientPageHeader: FC<ClientPageHeaderProps> = ({ publicProfile, info, isPublic, forceActiveTab }) => {
  return (
    <Box backgroundColor="n0" borderBottom="primary" sx={{ position: "relative", width: "100%", zIndex: 0 }}>
      {publicProfile.backgroundImage && <ClientPageCoverImage image={publicProfile.backgroundImage} />}

      <Box sx={{ pt: [52, null, null, 208] }}>
        <Container>
          <Grid columns="1fr" gap={20}>
            <Box px="sm">
              <Grid columns="1fr" gap={20}>
                <Flex>
                  <ClientPageLogo name={publicProfile.name} logo={publicProfile.logo} />
                </Flex>

                <Heading size={["h-md", null, null, "h-lg"]}>{publicProfile.name}</Heading>
              </Grid>
            </Box>

            <Box px={[null, null, null, "sm"]}>
              <ClientPageNavigationTabs
                publicProfile={publicProfile}
                info={info}
                isPublic={isPublic}
                forceActiveTab={forceActiveTab}
              />
            </Box>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};
